import React from "react";
import "./Skills.css";
import { Skill } from "../../components";
import cssLogo from "../../assets/images/CSS_Logo.png";
import djangoLogo from "../../assets/images/Django_Logo.png";
import expressLogo from "../../assets/images/Express_Logo.png";
import figmaLogo from "../../assets/images/Figma_Logo.png";
import filmoraLogo from "../../assets/images/Filmora_Logo.png";
import firebaseLogo from "../../assets/images/Firebase_Logo.png";
import gitLogo from "../../assets/images/Git_Logo.png";
import gitHubLogo from "../../assets/images/GitHub_Logo.png";
import HTMLLogo from "../../assets/images/HTML_Logo.png";
import javaScriptLogo from "../../assets/images/JS_Logo.png";
import mongoDBLogo from "../../assets/images/MongoDB_Logo.png";
import nodeJSLogo from "../../assets/images/NodeJS_Logo.png";
import photoshopLogo from "../../assets/images/Photoshop_Logo.png";
import PHPLogo from "../../assets/images/PHP_Logo.png";
import flaskLogo from "../../assets/images/Flask_Logo.png";
import postgresLogo from "../../assets/images/Postgresql_Logo.png";
import reactLogo from "../../assets/images/React_Logo.png";
import SQLLogo from "../../assets/images/SQL_Logo.png";
import wordPressLogo from "../../assets/images/WordPress_Logo.png";
import pythonLogo from "../../assets/images/Python_Logo.png";

const Skills = () => {
  const skills = [
    { image: HTMLLogo, description: "HTML" },
    { image: cssLogo, description: "CSS" },
    { image: javaScriptLogo, description: "JavaScript" },
    { image: reactLogo, description: "React" },
    { image: expressLogo, description: "Express" },
    { image: nodeJSLogo, description: "NodeJS" },
    { image: pythonLogo, description: "Python" },
    { image: djangoLogo, description: "Django" },
    { image: flaskLogo, description: "Flask" },
    { image: PHPLogo, description: "PHP" },
    { image: mongoDBLogo, description: "MongoDB" },
    { image: postgresLogo, description: "PostgreSQL" },
    { image: SQLLogo, description: "MySQL" },
    { image: gitLogo, description: "Git" },
    { image: gitHubLogo, description: "GitHub" },
    { image: firebaseLogo, description: "Firebase" },
    { image: figmaLogo, description: "Figma" },
    { image: photoshopLogo, description: "Adobe Photoshop" },
    { image: wordPressLogo, description: "WordPress" },
    { image: filmoraLogo, description: "Filmora" },
  ];
  return (
    <div id="skills">
      <h1>Skills</h1>
      <div className="skills-wrapper">
        <div className="skills-wrapper-track">
          {skills.map(({ image, description }) => (
            <Skill key={description} image={image} description={description} />
          ))}
          {skills.map(({ image, description }) => (
            <Skill key={description} image={image} description={description} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
